
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
export default [
  {
    name: "joboffers-details",
    path: "/karriere/stellenangebote/:slug()",
    component: () => import("/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/app/pages/karriere/stellenangebote/[slug].vue").then((m) => Object.assign(m.default, { __name: "joboffers-details" }))
  },
  {
    name: "joboffers-list",
    path: "/karriere/stellenangebote",
    component: () => import("/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/app/pages/karriere/stellenangebote/index.vue").then((m) => Object.assign(m.default, { __name: "joboffers-list" }))
  },
  {
    name: "fachbereiche-slug",
    path: "/fachbereiche/:slug()",
    component: () => import("/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/app/pages/fachbereiche/[slug].vue").then((m) => Object.assign(m.default, { __name: "fachbereiche-slug" }))
  },
  {
    name: "news-details",
    path: "/news/:slug()",
    component: () => import("/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/app/pages/news/[slug].vue").then((m) => Object.assign(m.default, { __name: "news-details" }))
  },
  {
    name: "babygallery-list",
    path: "/babygalerie",
    component: () => import("/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/app/pages/babygalerie.vue").then((m) => Object.assign(m.default, { __name: "babygallery-list" }))
  },
  {
    name: "fachbereiche",
    path: "/fachbereiche",
    component: () => import("/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/app/pages/fachbereiche/index.vue").then((m) => Object.assign(m.default, { __name: "fachbereiche" }))
  },
  {
    name: "contact",
    path: "/kontakt",
    component: () => import("/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/app/pages/kontakt.vue").then((m) => Object.assign(m.default, { __name: "contact" }))
  },
  {
    name: "news-list",
    path: "/news",
    component: () => import("/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/app/pages/news/index.vue").then((m) => Object.assign(m.default, { __name: "news-list" }))
  },
  {
    name: "article-detail",
    path: "/:category_slug()/:article_slug()",
    component: () => import("/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/app/pages/[category_slug]/[article_slug].vue").then((m) => Object.assign(m.default, { __name: "article-detail" }))
  },
  {
    name: "standalone-article-detail",
    path: "/:article_slug()",
    component: () => import("/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/app/pages/[article_slug].vue").then((m) => Object.assign(m.default, { __name: "standalone-article-detail" }))
  },
  {
    name: "standort-slug",
    path: "/standort-:slug()",
    component: () => import("/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/app/pages/standort-[slug].vue").then((m) => Object.assign(m.default, { __name: "standort-slug" }))
  },
  {
    name: "index",
    path: "/",
    component: () => import("/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: "index" }))
  }
]